import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	objectLabel: {
		id: 'servicedesk-insight-object-view.header.name-inline-edit.object-label',
		defaultMessage: 'Object label',
		description:
			'The name of this special type of CMDB attribute shown within the context of an error messaging saying that the name can not be blank.',
	},
	unknownError: {
		id: 'servicedesk-insight-object-view.header.name-inline-edit.unknown-error',
		defaultMessage: 'Unknown error',
		description: 'Label indicating that an unkonwn error occurred while saving the field value',
	},
	inlineEditLabel: {
		id: 'servicedesk-insight-object-view.header.name-inline-edit.inline-edit-label',
		defaultMessage: 'Enter object label',
		description: 'Label for inline edit field',
	},
	editButtonLabel: {
		id: 'servicedesk-insight-object-view.header.name-inline-edit.edit-button-label',
		defaultMessage: 'Edit object label',
		description: 'Label for inline edit button',
	},
});
